var map = {
	"./add.png": "Zarb",
	"./clock.png": "uZcP",
	"./collection.png": "hfNW",
	"./cybg_banner.png": "mfl0",
	"./cybg_gg_1.png": "IT8L",
	"./cyfw_banner_1.png": "E2Y4",
	"./cyfw_index_01.png": "6EHL",
	"./cyfw_index_02.png": "7GG9",
	"./cyfw_index_3_1.png": "kiAL",
	"./cyfw_index_3_2.png": "zIWW",
	"./cyfw_index_4_1.png": "kRG2",
	"./cyfw_index_4_2.png": "7wcP",
	"./cyfw_index_4_3.png": "6g9t",
	"./cyfw_index_4_4.png": "XKZc",
	"./cyfw_index_4_5.png": "nO/z",
	"./cyfw_index_4_6.png": "y/IX",
	"./download-app-1.png": "sbaP",
	"./eating.png": "bNfQ",
	"./fw_ico_bx1.png": "sKs0",
	"./fw_ico_bx2.png": "tvX7",
	"./fw_ico_dk.png": "XyyG",
	"./fw_ico_xd.png": "rD0m",
	"./fw_ico_zz.png": "ZDRt",
	"./fwlc_01.png": "q6hq",
	"./group_qr_code1.png": "KI2e",
	"./group_qr_code2.png": "O/i8",
	"./group_qr_code3.png": "H5CB",
	"./home_data_1.png": "X1EJ",
	"./home_data_2.png": "ak6l",
	"./home_gg_1.png": "cv+s",
	"./home_gg_2.png": "wJay",
	"./home_gg_2_backup.png": "ItgY",
	"./home_remark_01.png": "IYoK",
	"./home_remark_02.png": "NOpE",
	"./home_remark_03.png": "qr7Q",
	"./hync_banner.png": "mDHG",
	"./hync_er.png": "gFC+",
	"./index_banner.png": "HUpC",
	"./index_banner2.png": "7ZmL",
	"./index_banner4.png": "8su3",
	"./index_banner5.png": "MFKt",
	"./kjfw_banner_01.png": "RYww",
	"./left_1.png": "zbof",
	"./left_2.png": "iSgu",
	"./loading.png": "Yyfi",
	"./location.png": "TL5K",
	"./logo.png": "7Otq",
	"./logo2.png": "xAza",
	"./lxwm_bg.png": "XZg0",
	"./no_data.png": "/AAl",
	"./phone.png": "UqHI",
	"./product_1.png": "j7Gm",
	"./qq.png": "rpJM",
	"./reduce.png": "AlPP",
	"./right_1.png": "YLW5",
	"./right_2.png": "M9vz",
	"./scm/bg.png": "8ZzR",
	"./search_1.png": "Fu/l",
	"./service1_0.png": "zoL2",
	"./service1_1.png": "RkO7",
	"./service2_0.png": "WqcR",
	"./service2_1.png": "kB9f",
	"./service3_0.png": "xJwj",
	"./service3_1.png": "L69A",
	"./service_icon_1.png": "g9Xh",
	"./service_icon_2.png": "qvng",
	"./service_icon_3.png": "qaZj",
	"./share.png": "az9f",
	"./storage.png": "4nx/",
	"./veg-chart.png": "AxbT",
	"./weixing.png": "+2NW",
	"./wl_01.png": "n0Ki",
	"./zjfw_01.png": "7zmf",
	"./zzjs_01.png": "3ZIH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 1